<tiime-table-anchor></tiime-table-anchor>
<table
  data-cy="documents-table"
  tiime-table
  tiimeStickyTable
  [dataSource]="documents"
  [trackBy]="trackById"
  [scrollContainer]="scrollContainer"
  matSort
  [matSortDisabled]="containerState | map: mapToDisabledSort"
  (matSortChange)="emitApplySort($event)"
  aria-label="Liste des documents"
>
  <ng-container [cdkColumnDef]="ColumnNames.type">
    <th scope="col" data-cy="documents-category-column-header" cdk-header-cell *cdkHeaderCellDef></th>
    <td cdk-cell *cdkCellDef="let document">
      <app-document-category-identifier-icon
        [documentCategory]="document.category"
      ></app-document-category-identifier-icon>
    </td>
  </ng-container>

  <ng-container [cdkColumnDef]="ColumnNames.createdAt">
    <th
      scope="col"
      data-cy="documents-created-at-column-header"
      cdk-header-cell
      *cdkHeaderCellDef
      mat-sort-header="created_at"
    >
      Dépôt
    </th>
    <td cdk-cell *cdkCellDef="let document">
      <span tiimeTooltip [tooltipContent]="documentCreatedAtTooltipTemplate" tooltipClass="tiime-tooltip">
        {{ document.createdAt | date: 'shortDate' }}
      </span>
      <ng-template #documentCreatedAtTooltipTemplate>
        <div class="tiime-tooltip-content">Déposé le {{ document.createdAt | date: 'dd/MM/YYYY à HH:mm' }}</div>
      </ng-template>
    </td>
  </ng-container>

  <ng-container [cdkColumnDef]="ColumnNames.name">
    <th scope="col" data-cy="documents-name-column-header" cdk-header-cell *cdkHeaderCellDef mat-sort-header="name">
      Intitulé
    </th>
    <td cdk-cell *cdkCellDef="let document">
      <span
        tiimeTooltip
        [tooltipContent]="documentNameTooltipTemplate"
        tooltipClass="tiime-tooltip"
        tooltipHideWithoutEllipsis
      >
        {{ document.name }}
      </span>
      <ng-template #documentNameTooltipTemplate>
        <div class="tiime-tooltip-content">
          {{ document.name }}
        </div>
      </ng-template>
    </td>
  </ng-container>

  <ng-container [cdkColumnDef]="ColumnNames.tags">
    <th scope="col" data-cy="documents-tags-column-header" cdk-header-cell *cdkHeaderCellDef mat-sort-header="tags">
      <span class="two-lines-header-cell">
        Tags
        <br />
        client
      </span>
    </th>
    <td class="visible-cell" cdk-cell *cdkCellDef="let document">
      @if (document.tags?.length) {
        <app-tag-list-icon [tags]="document.tags" tooltipPosition="left"></app-tag-list-icon>
      }
    </td>
  </ng-container>

  <ng-container [cdkColumnDef]="ColumnNames.comment">
    <th
      scope="col"
      data-cy="documents-comment-column-header"
      cdk-header-cell
      *cdkHeaderCellDef
      mat-sort-header="comment"
    >
      <span class="two-lines-header-cell">
        Comm.
        <br />
        client
      </span>
    </th>
    <td cdk-cell *cdkCellDef="let document">
      @if (document.comment) {
        <app-comment-cell [comment]="document.comment"></app-comment-cell>
      }
    </td>
  </ng-container>

  <ng-container [cdkColumnDef]="ColumnNames.actions">
    <th scope="col" data-cy="documents-actions-column-header" cdk-header-cell *cdkHeaderCellDef></th>
    <td class="visible-cell" cdk-cell *cdkCellDef="let document">
      <button
        class="show-on-hover"
        tiime-button
        color="warn"
        raised
        icon
        (click)="$event.stopPropagation(); emitDeleteDocument(document)"
      >
        <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-corbeille-on"></mat-icon>
      </button>
    </td>
  </ng-container>

  <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
  <tr
    data-cy="documents-row"
    cdk-row
    *cdkRowDef="let document; let e = even; columns: displayedColumns"
    [class.alternate]="e"
    (click)="emitOpenDocumentDialog(document)"
  ></tr>
</table>
